/**
 * 检测操作系统类型
 * @returns 'mac' | 'windows' | 'linux' | 'unknown'
 */
export const getOS = (): 'mac' | 'windows' | 'linux' | 'unknown' => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (platform.includes('mac') || userAgent.includes('mac')) {
    return 'mac';
  } else if (platform.includes('win') || userAgent.includes('windows')) {
    return 'windows';
  } else if (platform.includes('linux') || userAgent.includes('linux')) {
    return 'linux';
  }
  return 'unknown';
};

/**
 * 检测是否运行在 Electron 环境中
 * @returns boolean
 */
export const isElectron = (): boolean => {
  // 方法1: 检查 userAgent
  if (typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('electron')) {
    return true;
  }
  
  // 方法2: 检查 window.process.versions.electron
  if (typeof window !== 'undefined' && (window as any).process && (window as any).process.versions && (window as any).process.versions.electron) {
    return true;
  }
  
  // 方法3: 检查 window.require (Electron 会注入)
  if (typeof window !== 'undefined' && typeof (window as any).require === 'function') {
    try {
      // 尝试检测 Electron 的 require
      const electron = (window as any).require && (window as any).require('electron');
      if (electron) {
        return true;
      }
    } catch (e) {
      // 忽略错误
    }
  }
  
  return false;
};
